import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import config from './config.js'

axios.defaults.baseURL =  config.baseURL
axios.defaults.headers.post['Content-Type'] = 'application/json'


new Vue({
  el: '#app',
  router,
  vuetify,
  render: h => h(App)
})
